import { render, staticRenderFns } from "./chats.vue?vue&type=template&id=ca68e6ca&"
import script from "./chats.vue?vue&type=script&lang=js&"
export * from "./chats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca68e6ca')) {
      api.createRecord('ca68e6ca', component.options)
    } else {
      api.reload('ca68e6ca', component.options)
    }
    module.hot.accept("./chats.vue?vue&type=template&id=ca68e6ca&", function () {
      api.rerender('ca68e6ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/chats.vue"
export default component.exports